import { Component, input, OnInit, signal } from '@angular/core';
import { delay } from '@gametailors/web-core/misc';
import { WordToKlankConverter } from '../../utils/klank.utils';

@Component({
  selector: 'rid-segmented-word-card',
  imports: [],
  templateUrl: './rid-segmented-word-card.html',
  styleUrl: './rid-segmented-word-card.css',
  host: {
    class: 'block',
  },
})
export class RidSegmentedWordCard implements OnInit {
  segments = input.required<string[]>();
  mode = input<'NORMAL' | 'READING'>('NORMAL');
  hideText = input(false);

  styledSegments = signal<{ text: string; opacity: number; duration: number }[][]>([]);
  isCompressed = signal(false);

  ngOnInit(): void {
    const mode = this.mode();

    if (mode === 'NORMAL') {
      this.isCompressed.set(true);
      this.styledSegments.set(this.toStyledSegments(1));
    } else if (mode === 'READING') {
      this.styledSegments.set(this.toStyledSegments(0.5));
    }
  }

  async compress(opacity = 0.5) {
    this.isCompressed.set(true);
    this.styledSegments.update((segment) => {
      segment.forEach((card) => {
        card.forEach((klank) => {
          klank.opacity = opacity;
          klank.duration = 200;
        });
      });
      return [...segment];
    });

    await delay(250);
  }

  async decompress() {
    this.isCompressed.set(false);
    await delay(250);
  }

  async pass(pace: number, onCompress?: () => void) {
    // highlight at read pace
    await this.read(pace);

    // compress the word
    onCompress?.();
    await this.compress();

    // wait
    await delay(200);

    // highlight at say-pace
    await this.read(25);
  }

  private async read(pace: number) {
    for (let i = 0; i < this.styledSegments().length; i++) {
      const duration = this.getSegmentDuration(this.segments()[i], pace);

      this.styledSegments.update((segments) => {
        segments[i][0].opacity = 1;
        segments[i][0].duration = duration;
        return [...segments];
      });

      await delay(duration);
    }
  }

  private toStyledSegments(opacity: number) {
    return this.segments().map((segment) => [
      {
        text: segment,
        opacity,
        duration: 0,
      },
    ]);
  }

  private getSegmentDuration(segment: string, pace: number) {
    return WordToKlankConverter.breakupWord(segment).length * pace;
  }

  async hide() {
    this.styledSegments.set(
      this.styledSegments().map((segment) => {
        return segment.map((klank) => {
          return {
            text: klank.text,
            opacity: 0,
            duration: 200,
          };
        });
      }),
    );

    await delay(200);
  }

  async show() {
    this.styledSegments.set(
      this.styledSegments().map((segment) => {
        return segment.map((klank) => {
          return {
            text: klank.text,
            opacity: 1,
            duration: 200,
          };
        });
      }),
    );

    await delay(200);
  }
}
